import React from 'react';

export const Text = ({ label, input }) => {
  return (
    <div>
      <label>{label} <span className="required">*</span></label>
      <input type="text" size={35} {...input} />
    </div>
  );
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Contact/Text.js